var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"examination_boxs"},[_c('iframe',{staticClass:"iframes",attrs:{"src":_vm.src,"frameborder":"0","id":"iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }